import React from 'react';

const MainInfo = () => {

    return (
          <div className={"container mt-5"}>
              <div className={"row"}>
                <div className={"d-none d-lg-block col-lg-2"}>

                </div>
                <div className={"col-12 col-lg-8 text-center"}>
                      <h1>Herzlich Willkommen</h1>
                      <h2 className={"h3"}>
                        zum 4. interdisziplinären Fachkongress mit augenärztlicher Weiterbildung des SightCity Forum Beirats zum Thema:<br /><br />
                        Versorgungskonzepte in der Rehabilitation neu gedacht!<br />
                      </h2>
                  </div>
              </div>
              <div className={"row mt-4"}>
                  <div className={"col-12 text-center"}>
                      <p className={"lead"}>
                          Mittwoch, 21.05.2025, 13:00 Uhr bis 18:30 Uhr
                      </p>
                  </div>
                  <div className={"col-12 text-center mt-4"}>
                      <div className={"fw-bold lead"}>
                          Hier geht es zur Registrierung:<br />
                          <a href={"https://us06web.zoom.us/webinar/register/WN_rTXAzWfZQTGHN0ztlbDm4Q"} target={"_blank"} rel={"noreferrer noopener"}>
                              <button className={"btn btn-primary btn-lg mt-2"}>Zur Registrierung</button>
                          </a>
                      </div>
                  </div>
              </div>
          </div>
    );
};

export default MainInfo;
